module.exports = __webpack_public_path__ + "static/media/cheyenne_lu.86200ca0.png";